/* unplugin-vue-components disabled */import script from "./message-input-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-input-editor.vue?vue&type=script&setup=true&lang=ts"

import "./message-input-editor.vue?vue&type=style&index=0&id=d6dd9aca&scoped=true&lang=scss"
import "./message-input-editor.vue?vue&type=style&index=1&id=d6dd9aca&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6dd9aca"]])

export default __exports__